import { logger } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import type { Store } from '@fiverr-private/store_builder_types';
import pathfinder from '@fiverr-private/pathfinder';
import { CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';
import { handleApiError } from '../utils/handle-api-error/handleApiError';

interface VerifyAuthCallback {
    storeId: Store['id'];
    params: {
        code: string;
    };
}

const ENDPOINT = 'verify_auth_callback';

export const verifyAuthCallback = async ({ storeId, params }: VerifyAuthCallback): Promise<boolean> => {
    const { pageCtxId } = getContext();
    const body = { ...params };

    const url = pathfinder('ai_store_builder_api_post', {
        version: 'v1',
        store_id: storeId,
        endpoint: ENDPOINT,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: ENDPOINT,
    };

    try {
        const response = await maxios.post(url, body, options);
        return response.status === 200;
    } catch (error) {
        logger.error(error as Error, {
            page_ctx_id: pageCtxId,
            description: 'Failed to verify auth callback',
            store_id: storeId,
            params,
        });

        throw handleApiError(error);
    }
};
